import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export class Footer {

  public show = false;
  public logo = false;
  public testimonial = false;
  public backToMerchant = false;
  public cancelOrder = false;
  public popup = false;

  constructor(showFooter: boolean, showLogo: boolean, showTestimonial: boolean, showBackButton: boolean, callCancelOrder: boolean, showPopup: boolean) {
    this.show = showFooter;
    this.logo = showLogo;
    this.testimonial = showTestimonial;
    this.backToMerchant = showBackButton;
    this.cancelOrder = callCancelOrder;
    this.popup = showPopup;
  }
}

@Injectable()

export class FooterService {

  public ShowFooterSource = new Subject<Footer>();
  toggleFooter$: any = this.ShowFooterSource.asObservable();

  constructor() { }

}
